/* unplugin-vue-components disabled */import { render } from "./barChart.vue?vue&type=template&id=793c20a2"
import script from "./barChart.vue?vue&type=script&lang=js"
export * from "./barChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__